var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_vm._v(" "),(!_vm.isExternalLink)?_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [(_vm.cajaOnline && !_vm.esSelfi)?[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('cajaOnline'),
              icon: 'fa fa-eye',
              path: '/cajas-online',
            }}})]:_vm._e(),_vm._v(" "),(_vm.informes && !_vm.esSelfi)?[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('informes'),
              icon: 'fa fa-chart-bar',
              path: '/informes',
              isRoute: true,
            }}})]:_vm._e(),_vm._v(" "),(_vm.pedidosProveedor && !_vm.esSelfi)?[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('pedidosProveedor'),
              icon: 'fas fa-tags',
              path: '/pedidos-proveedor',
            }}})]:_vm._e(),_vm._v(" "),(_vm.gastos && !_vm.esSelfi)?[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('gastos'),
              icon: 'fa fa-credit-card',
              path: '/gestion-gastos',
            }}})]:_vm._e(),_vm._v(" "),(_vm.almacen && !_vm.esSelfi)?[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('almacen'),
              icon: 'fas fa-warehouse',
              path: '/almacen',
            }}})]:_vm._e(),_vm._v(" "),(_vm.configuracion && !_vm.esSelfi)?[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('configuracion'),
              icon: 'fa fa-cogs',
              path: '/configuracion',
            }}})]:_vm._e(),_vm._v(" "),(_vm.posicionGlobal && !_vm.esSelfi)?[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('posicionGlobal'),
              icon: 'fa fa-globe',
              path: '/posicion-global',
            }}})]:_vm._e(),_vm._v(" "),(_vm.gestionDePersonal && _vm.negocioGestionDePersonal && !_vm.esSelfi)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('gestionDePersonal'),
            icon: 'fas fa-user-clock',
            path: '/calendar',
          }}}):_vm._e(),_vm._v(" "),(!_vm.esSelfi)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('soporteOnline'),
            icon: 'fa fa-envelope',
            path: '/soporte-online',
          }}}):_vm._e(),_vm._v(" "),(_vm.configuracionCarta && _vm.carta && _vm.soloRetail && _vm.esSelfi)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('configuracionCarta'),
            icon: 'fas fa-cogs',
            path: '/configuracion-carta',
          }}}):_vm._e(),_vm._v(" "),[(_vm.esSelfi)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('guiaUsuario'),
              icon: 'fas fa-book',
              path: '/guia-usuario',
            }}}):_vm._e()],_vm._v(" "),(_vm.carta && _vm.soloRetail && !_vm.esSelfi)?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('carta'), icon: 'fas fa-shopping-basket' }}},[(_vm.gestionPedidos)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('gestionDePedidos'),
              icon: 'fas fa-utensils',
              path: '/delivery',
            }}}):_vm._e(),_vm._v(" "),(_vm.configuracionCarta)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('configuracionCarta'),
              icon: 'fas fa-cogs',
              path: '/configuracion-carta',
            }}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.amorino)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('importacionExcels'),
            icon: 'far fa-file-excel',
            path: '/importacion',
          }}}):_vm._e(),_vm._v(" "),(_vm.integracion)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('integraciones'),
            icon: 'fa-solid fa-circle-nodes',
            path: '/integraciones',
          }}}):_vm._e(),_vm._v(" "),(_vm.log)?_c('sidebar-item',{attrs:{"link":{
            name: 'LOG',
            icon: 'fa-solid fa-fingerprint',
            path: '/log',
          }}}):_vm._e()]}}],null,false,228466153)},[_c('mobile-menu')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-panel"},[(!_vm.isExternalLink)?_c('top-navbar'):_vm._e(),_vm._v(" "),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}}),_vm._v(" "),_c('content-footer')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d17ba87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Layout/DashboardLayout.vue
// module id = VrIi
// module chunks = 4